var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#1855f1;}.d{fill:#7097f6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15,0A15,15,0,1,0,30,15,14.98,14.98,0,0,0,15,0m0,28.75A13.75,13.75,0,1,1,28.75,15,13.742,13.742,0,0,1,15,28.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18.82,7.571a11.25,11.25,0,1,0,11.25,11.25A11.267,11.267,0,0,0,18.82,7.571m0,21.249a10,10,0,1,1,10-10,10.029,10.029,0,0,1-10,10",
    transform: "translate(-3.82 -3.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.645,24.831a2.219,2.219,0,0,0-2.2,2.2v5.8a2.2,2.2,0,1,0,4.4,0v-5.8a2.219,2.219,0,0,0-2.2-2.2m.95,8a.95.95,0,0,1-.95.95.92.92,0,0,1-.95-.95v-5.8a.949.949,0,0,1,.95-.95.92.92,0,0,1,.95.95Z",
    transform: "translate(-13.345 -12.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.645,15.14a2.2,2.2,0,1,0,2.2,2.2,2.219,2.219,0,0,0-2.2-2.2m0,3.15a.949.949,0,0,1-.95-.95.95.95,0,1,1,.95.95",
    transform: "translate(-13.345 -7.64)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual1);
export default __webpack_public_path__ + "static/media/Icon-individual-1.2b1faffe1cf43918eca7042cbd6e4d71.svg";
export { ForwardRef as ReactComponent };